export default "__VITE_ASSET__633433ac__"